const dataRoadmap = [
    {
        id: 1,
        title: 'PHASE 1',
        class: 'left',
        list: [
            {
                id: 1,
                text: 'Boost your FIFA Ultimate Team with FC 25 Coins',
            },
            {
                id: 2,
                text: 'Safe FC 25 Coins for sale with 100% protection',
            },
            {
                id: 3,
                text: 'Cheapest EA Sports FC 25 Coins available',
            },
            {
                id: 4,
                text: 'Affordable FC 25 Coins with instant delivery',
            },
        ],
    },
    {
        id: 2,
        title: 'PHASE 2',
        class: 'right',
        list: [
            {
                id: 1,
                text: 'Buy FUT 25 Coins securely with no ban guarantee',
            },
            {
                id: 2,
                text: 'Top tips for trading FC 25 Coins safely',
            },
            {
                id: 3,
                text: 'Fast and secure FC 25 Coins transfer service',
            },
            {
                id: 4,
                text: 'Get FIFA Coins quickly and affordably',
            },
        ],
    },
    {
        id: 3,
        title: 'PHASE 3',
        class: 'left',
        list: [
            {
                id: 1,
                text: 'Best deals on EA FC 25 Coins online',
            },
            {
                id: 2,
                text: 'Buy FC 25 Coins in [Your Location]',
            },
            {
                id: 3,
                text: 'Top site for cheap FUT Coins',
            },
            {
                id: 4,
                text: 'Buy FIFA Coins with secure PayPal payments',
            },
        ],
    },
    {
        id: 4,
        title: 'PHASE 4',
        class: 'right',
        list: [
            {
                id: 1,
                text: 'Learn how to transfer FUT Coins safely',
            },
            {
                id: 2,
                text: 'Best site like Masterfut for FUT Coins',
            },
            {
                id: 3,
                text: 'Avoid scams when buying EA FC Coins',
            },
            {
                id: 4,
                text: 'Get FUT Coins with crypto payment options',
            },
        ],
    },
    {
        id: 5,
        title: 'PHASE 5',
        class: 'left',
        list: [
            {
                id: 1,
                text: 'Buy cheap EA FC 25 Coins with comfort trade delivery',
            },
            {
                id: 2,
                text: 'FIFA Coins store trusted by players worldwide',
            },
            {
                id: 3,
                text: 'Fast EA FC Coins delivery to Xbox, PS, and PC',
            },
            {
                id: 4,
                text: 'Where to buy FUT Coins online safely',
            },
        ],
    },
    {
        id: 6,
        title: 'PHASE 6',
        class: 'right',
        list: [
            {
                id: 1,
                text: 'EA FC 25 Coins store with no ban guarantee',
            },
            {
                id: 2,
                text: 'Get cheap FIFA Coins with fast delivery',
            },
            {
                id: 3,
                text: 'Affordable EA FC Coins for PlayStation, Xbox, and PC',
            },
            {
                id: 4,
                text: 'Securely buy Ultimate Team Coins today',
            },
        ],
    },
];

export default dataRoadmap;
